import { render, staticRenderFns } from "./QRole.vue?vue&type=template&id=3c2f7d2e&scoped=true&"
import script from "./QRole.vue?vue&type=script&lang=js&"
export * from "./QRole.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c2f7d2e",
  null
  
)

export default component.exports